import React from 'react';
import { FieldError, useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import TopFieldContent from '../../../../Components/Form/components/TopFieldContent';
import ErrorMessage from '../../../../Components/Form/components/ErrorMessage';
import NCZIExtensionSearchSelect from './NCZIExtensionSearchSelect';

export interface NCZIExtensionSelectError {
	value?: {
		code?: FieldError;
	};
}

interface Props {
	label?: string;
	name: string;
	isRequired?: boolean;
	className?: string;
	oid: string;
	showCode?: boolean;
	onlyVaccination?: boolean;
	showAdditionalName?: boolean;
}

const NCZIExtensionSearchSelectField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
	oid,
	showCode = false,
	onlyVaccination = false,
	showAdditionalName = false,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	const extensionError = error as NCZIExtensionSelectError;

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<NCZIExtensionSearchSelect
				oid={oid}
				{...field}
				showCode={showCode}
				error={extensionError?.value?.code}
				onlyVaccination={onlyVaccination}
				showAdditionalName={showAdditionalName}
			/>
			{extensionError?.value?.code?.message && (
				<ErrorMessage tx={extensionError?.value?.code?.message} />
			)}
		</div>
	);
};

export default NCZIExtensionSearchSelectField;
